import { alpha, Theme } from '@material-ui/core/styles';
import { MenuItemClassKey } from '@material-ui/core/MenuItem';

const MuiMenuItem = (theme: Theme): Partial<Record<MenuItemClassKey, unknown>> => ({
    root: {
        '&$selected': {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity,
                ),
            },
        },
    },
    selected: {},
});

export default MuiMenuItem;
